module.exports = require("assert");


//////////////////
// WEBPACK FOOTER
// external "assert"
// module id = 356
// module chunks = 0